<template>
  <button
    :disabled="disabled"
    class="base-button"
    :class="[
      width,
      xPadding,
      yPadding,
      borderRadius,
      fontSize,
      color,
      border,
      shadow,
      borderColor,
      disabled ? 'cursor-not-allowed bg-gray-dark' : backgroundColor,
      hover,
      cursor,
      justify,
    ]"
    :type="type"
    @click.stop="action"
  >
    <slot v-if="!loading" name="icon"></slot>
    <div class="flex items-center">
      <Spinner v-if="loading" class="mr-3" />
      <span>
        {{ text }}
      </span>
    </div>
  </button>
</template>

<script>
import Spinner from '@/components/shared/spinner/Spinner';
export default {
  name: 'BaseButton',
  components: { Spinner },
  props: {
    loading: { type: Boolean, default: false },
    width: { type: String, default: 'w-auto' },
    text: { type: String, default: '' },
    xPadding: { type: String, default: 'px-5' },
    yPadding: { type: String, default: 'py-3' },
    borderRadius: { type: String, default: 'rounded-full' },
    border: { type: String, default: 'border' },
    borderColor: { type: String, default: 'border-transparent' },
    fontSize: { type: String, default: 'body-xs-500' },
    color: { type: String, default: 'text-white' },
    backgroundColor: { type: String, default: 'primary-btn-bg-color' },
    hover: { type: String, default: 'hover:from-primary-dark hover:to-primary-dark' },
    shadow: { type: String, default: '' },
    cursor: { type: String, default: 'cursor-pointer' },
    disabled: { type: Boolean, default: false },
    type: { type: String, default: 'submit' },
    justify: { type: String, default: 'justify-center' },
  },
  methods: {
    action() {
      this.$emit('onClick');
    },
  },
};
</script>
<style lang="scss" scoped>
.base-button {
  @apply flex items-center transition-all duration-300 ease-in outline-none focus:outline-none;
}
</style>
